import React, { useEffect, useState } from "react";
import style from "./CandidateRetentions.module.scss";
import { BiFilterAlt } from "react-icons/bi";
import { AiOutlineClose } from "react-icons/ai";
import { decryptedAdminID, dateFormate, MyModal } from "../../../utility";
import ModalContainer from "../../../components/modal_popup";
import { Form, FormGroup, InputGroup } from "react-bootstrap";
import indiaFlag from "../../../assets/images/flag.png";
import { useSelector } from "react-redux";
import { Typeahead } from "react-bootstrap-typeahead";
import { GetAllAdminDetails } from "../../../apiServices";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch } from "react-redux";
import { CandidateRetentionActions } from "../../../redux-store/store";

function CandidateRetentionFilter() {
  const candidateRetentionsFilter = useSelector(
    (state) => state.CandidateRetentionDetails.retentionsFilter
  );
  const [openFilterData, setopenFilterData] = useState(false);
  const [adminList, setAdminList] = useState([]);

  const adminDetailsRole = useSelector((state) => state.adminDetails);
  const isSuperAdmin = adminDetailsRole.roleID === 1;
  const admin = decryptedAdminID();

  const initialState = {
    assignTo: admin == 1 ? -1 : admin,
    // assignTo: -1,
    status: candidateRetentionsFilter.status,
    issueFaced: candidateRetentionsFilter.issueFaced,
    resolved: candidateRetentionsFilter.resolved,
    weekStatus: candidateRetentionsFilter.weekStatus,
    mobileNumber: candidateRetentionsFilter.mobileNumber,
    joinedDate: candidateRetentionsFilter.joinedDate,
    companyName: candidateRetentionsFilter.companyName,
    page: 0,
    size: 120,
  };
  const [filterData, setfilterData] = useState(initialState);
  const Dispatch = useDispatch();
  useEffect(() => {
    GetAllAdminDetails()
      .then((data) => {
        const activeAdmins = data.filter(
          (item) => !item.Deactived && item.Module !== "Developer"
        );
        setAdminList(activeAdmins);
      })
      .catch(() => {
        alert("Something went wronghhh");
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobileNumber") {
      const validMobileNumber = /^\d{0,10}$/.test(value);
      if (!validMobileNumber) return;
    } else if (name === "companyName") {
      const validCompanyName =
        /^[A-Za-z\s\W]*$/.test(value) && !/\d/.test(value);
      if (!validCompanyName) return;
    } else if (name === "weekStatus") {
      const validWeekStatus = /^\d{0,2}$/.test(value);
      if (!validWeekStatus) return;
    } else if (name === "issueFaced") {
      const validIssueFaced = /^[A-Za-z\s]*$/.test(value);
      if (!validIssueFaced) return;
    }

    setfilterData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleDateChange = (date) => {
    setfilterData((prevState) => ({
      ...prevState,
      joinedDate: dateFormate(date),
    }));
  };

  const handleAssignToChange = (selected) => {
    const adminID = selected.length > 0 ? selected[0].id : "";
    setfilterData((prevState) => ({
      ...prevState,
      assignTo: adminID,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    Dispatch(CandidateRetentionActions.setCanRetentionsFilter(filterData));
    console.log(filterData, "filter");
    setopenFilterData(false);
  };

  const handleClear = () => {
    setfilterData(initialState);
    Dispatch(
      CandidateRetentionActions.setCanRetentionsFilter({
        assignTo: admin == 1 ? -1 : admin,
        status: "",
        issueFaced: "",
        resolved: "",
        weekStatus: "",
        mobileNumber: "",
        joinedDate: "",
        companyName: "",
        page: 0,
        size: 120,
      })
    );
  };

  return (
    <div>
      <button
        className={`d-flex align-items-center ${style.CandidateFilter}`}
        onClick={() => setopenFilterData(true)}
      >
        {" "}
        <BiFilterAlt className="me-2" /> Filter
      </button>
      {openFilterData && (
        <MyModal>
          <ModalContainer
            zIndex={1001}
            childComponent={
              <>
                <div style={{ width: "1000px" }}>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div>
                      <b>Candidate Retention Filter</b>{" "}
                    </div>
                    <div
                      className="btn btn-danger"
                      onClick={() => setopenFilterData(false)}
                    >
                      <AiOutlineClose />
                    </div>
                  </div>
                  <div>
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-sm-3">
                          <InputGroup className="mb-3">
                            <InputGroup.Text id="basic-addon1">
                              <img src={indiaFlag} alt="flag" width={30} />
                            </InputGroup.Text>
                            <Form.Control
                              name="mobileNumber"
                              placeholder="Mobile Number"
                              aria-label="Mobile Number"
                              aria-describedby="basic-addon1"
                              value={filterData.mobileNumber}
                              onChange={handleChange}
                            />
                          </InputGroup>
                        </div>
                        {isSuperAdmin && (
                          <div className="col-sm-3">
                            <FormGroup>
                              <Typeahead
                                id="assign-to-typeahead"
                                placeholder="Assigned To"
                                options={adminList}
                                labelKey={(option) => `${option.userName}`}
                                onChange={handleAssignToChange}
                                selected={
                                  filterData.assignTo !== -1
                                    ? adminList.filter(
                                        (admin) =>
                                          admin.id === filterData.assignTo
                                      )
                                    : []
                                }
                              />
                            </FormGroup>
                          </div>
                        )}
                        <div className="col-sm-3">
                          <Form.Control
                            type="text"
                            name="companyName"
                            placeholder="Company Name"
                            value={filterData.companyName}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="col-sm-3">
                          <FormGroup
                            style={{ width: "1000px" }}
                            className="w-100"
                          >
                            <DatePicker
                              selected={filterData.joinedDate}
                              onChange={handleDateChange}
                              placeholderText="DD/MM/YYYY - joined Date"
                              dateFormat="dd/MM/yyyy"
                              className={`form-control ${style["custom-datepicker"]}`}
                            />
                          </FormGroup>
                        </div>
                        {/* <div className="col-sm-3">
                          <Form.Control
                            type="text"
                            name="issueFaced"
                            placeholder="Issue"
                            value={filterData.issueFaced}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="col-sm-3">
                          <Form.Control
                            type="text"
                            name="weekStatus"
                            placeholder="Week"
                            value={filterData.weekStatus}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="col-sm-3">
                          <Form.Select
                            name="resolved"
                            aria-label="Problem Resolved"
                            style={{ cursor: "pointer" }}
                            value={filterData.resolved}
                            onChange={handleChange}
                          >
                            <option value="" disabled>
                              Resolved select options
                            </option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                          </Form.Select>
                        </div> */}
                      </div>

                      <div className="d-flex justify-content-end align-items-center mt-3 mb-1 gap-2">
                        <button
                          type="button"
                          className={style.ClearAll}
                          onClick={handleClear}
                        >
                          Clear
                        </button>
                        <button type="submit" className={style.SubmitButton}>
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </>
            }
          />
        </MyModal>
      )}
    </div>
  );
}

export default CandidateRetentionFilter;
